import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClienteService } from '../../../services/cliente/cliente.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { ConfigService } from '../../../services/config/config.service';
import { LocalizacionService } from '../../../services/localizacion/localizacion.service';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';

@Component({
  selector: 'app-creation-customer',
  templateUrl: './creation-customer.component.html',
  styleUrls: ['./creation-customer.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class CreationCustomerComponent implements OnInit {
  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  infoUser: any = {};
  empresa: any = {};
  infoParametrizacion: any = {};
  listDptos: Array<any> = [];
  listIdentificationType: Array<any> = [];
  selectedClient: any = {};
  digito: number | undefined;
  citySelected: any = {};
  listCities: Array<any> = [];
  infoTercero: any = {};
  displayInfoTercero: boolean = false;
  selectedChannelIngreso: any = {};
  messageClient: string = "";
  listCanalIngreso: Array<any> = [];
  listOfPrice: Array<any> = [];
  listOfBrancheOffice: Array<any> = [];
  selectedListOfPrice: any = {};
  displaySucursal: boolean = false;
  numberTempSucursal: number | undefined;

  formClient = new FormGroup({
    tipo: new FormControl({ idTipoIdentificacion: 0 }, Validators.required),
    identificacion: new FormControl(null, [Validators.required, Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    razonSocial: new FormControl('', Validators.required),
    nombres: new FormControl('', [Validators.required, Validators.maxLength(200)]),
    direccion: new FormControl(''),
    departamento: new FormControl(null),
    ciudad: new FormControl(null),
    correo: new FormControl('', [Validators.email, Validators.required]),
    telefono: new FormControl('', [Validators.pattern(/^(0|[1-9][0-9]*)$/)]),
    sucursal: new FormControl(null)
  });

  constructor(private client: ClienteService,
    private message: MessageService,
    private supplierIntegration: supplierIntegrationService,
    private config: ConfigService,
    private localizacion: LocalizacionService,
    private cotizacion: CotizacionService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");
    this.empresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");

    // get information of dptos
    this.listDptos = JSON.parse(localStorage.getItem('listDptos') ?? "[]");

    // get possible client entry channel
    this.client.getPossibleEntryChannel(this.token.token).subscribe({
      next: (response) => {
        this.listCanalIngreso = response as Array<any>;
      }, error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });

    // get identification types
    this.client.getTypeIndetification(this.token.token).subscribe({
      next: (response) => { this.listIdentificationType = response as Array<any>; },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    });

    // get list of prices
    this.getListofPrices()
  }

  searchClient() {
    if (((this.formClient.controls.identificacion.value ?? "") != '') && ((this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 0) > 0)) {
      // verification digit calculation
      this.digito = this.config.getDigitVerification(this.formClient.controls.identificacion.value ?? "");

      this.client.getClients(this.token.token, this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 1,
        this.formClient.controls.identificacion.value ?? "").subscribe((response) => {
          this.selectedClient = response as Array<any>;
          // load branche office of client
          this.listOfBrancheOffice = this.selectedClient[0]?.clienteSucursals ?? [];

          if (this.selectedClient.length > 0) {
            this.formClient.controls.nombres.setValue(this.selectedClient[0].nombres);
            this.formClient.controls.telefono.setValue(this.selectedClient[0].telefono);
            this.formClient.controls.correo.setValue(this.selectedClient[0].email);
            this.formClient.controls.direccion.setValue(this.selectedClient[0].direccion);
            this.formClient.controls.razonSocial.setValue(this.selectedClient[0].razonSocial ?? 'N/A');
            // to assign branche_ office
            if (this.listOfBrancheOffice.length == 1)
              this.formClient.controls.sucursal.setValue(this.listOfBrancheOffice[0]);

            // campos de complemento para estadisticas
            this.selectedChannelIngreso = this.listCanalIngreso.filter((row: any) => { return row.idProcedencia == this.selectedClient[0]?.clienteProcedencia[0]?.idProcedencia })[0];
            this.selectedListOfPrice = this.listOfPrice.filter((row: any) => { return row.idListaPrecios == this.selectedClient[0]?.clienteProcedencia[0]?.idListaPrecios })[0];
            // get city and depto
            if (!!this.selectedClient[0].idCiudad)
              this.localizacion.getCitiesId(this.token.token, this.selectedClient[0].idCiudad).subscribe({
                next: (response1) => {
                  this.citySelected = response1;
                  this.formClient.controls.departamento.setValue((response1 as any).idDepartamentoNavigation);
                  this.loadCities();
                },
                error: (error: HttpErrorResponse) => { this.config.handleError(error); }
              })
          } else
            this.searchClientExternSystem();
        });
    }
  }



  searchClientExternSystem = () => {
    /*Import Clients of SIIGO*/
    if (!!localStorage.getItem('tokenSIIGO')) {
      let tokenSIIGO = JSON.parse(localStorage.getItem('tokenSIIGO') ?? "");
      this.supplierIntegration.getClientSiigo(this.token.token, tokenSIIGO, this.formClient.controls.identificacion.value ?? "")
        .subscribe({
          next: (response) => {
            this.infoTercero = response as Array<any>;
            if (this.infoTercero.results.length > 0)
              this.displayInfoTercero = true;
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); }
        });
    }
  }

  fillFormClientExternSystem = () => {
    if (!!localStorage.getItem('tokenSIIGO')) {
      if (this.infoTercero.results.length > 0) {
        this.formClient.controls.tipo.setValue(this.listIdentificationType.filter(row => { return row.codProveedorDian1 == this.infoTercero.results[0].id_type.code.toString() })[0]);
        this.formClient.controls.nombres.setValue(this.infoTercero.results[0].contacts[0].first_name + " " + this.infoTercero.results[0].contacts[0].last_name);
        this.formClient.controls.telefono.setValue(this.infoTercero.results[0].phones[0].phone);
        this.formClient.controls.correo.patchValue(this.infoTercero.results[0].contacts[0].email);
        this.formClient.controls.direccion.setValue(this.infoTercero.results[0].address.address);
        this.formClient.controls.razonSocial.setValue(this.infoTercero.results[0].name.join(' '));

        // sucursal, se valida si existe
        this.infoTercero.results.map((item: any) => {
          if (this.listOfBrancheOffice.filter(row => row.sucursal == item.branch_office).length == 0)
            this.listOfBrancheOffice.push({ sucursal: item.branch_office, activo: item.active });
        })


        if (this.listOfBrancheOffice.length == 1)
          this.formClient.controls.sucursal.setValue(this.listOfBrancheOffice[this.listOfBrancheOffice.length - 1]);


        //show dpto
        this.formClient.controls.departamento.setValue(this.listDptos.filter(row => row.codDepartamento == this.infoTercero.results[0].address.city.state_code)[0]);
        // load cities and selected
        this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
          next: (response) => {
            this.listCities = response as Array<any>;
            // there is a selected city
            this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.codCiudad == this.infoTercero.results[0].address.city.city_code)[0]);
            this.displayInfoTercero = false;
          },
          error: (error: HttpErrorResponse) => { this.displayInfoTercero = false; }
        })
      }
    }
  }

  addSucursal = () => {
    if (this.selectedClient.length > 0) {
      if ((this.numberTempSucursal ?? 0) > 0) {
        if (this.listOfBrancheOffice.filter((row: any) => { return row.sucursal == this.numberTempSucursal }).length == 0) {
          this.listOfBrancheOffice.push({ sucursal: this.numberTempSucursal, activo: true });
          this.numberTempSucursal = 0;
        }
        else
          this.message.add({ severity: 'warn', detail: 'Código de sucursal ya existe' })
      } else
        this.message.add({ severity: 'warn', detail: 'Favor relacione el código de sucursal' })
    } else
      this.message.add({ severity: 'warn', detail: 'Favor seleccione el cliente' })
  }

  clearFormClient = () => {
    this.formClient.reset();
    this.selectedChannelIngreso = {};
    this.selectedListOfPrice = {};
    this.listOfBrancheOffice = [];
  }

  saveInfoClient = () => {
    // si se edita la información es necesario guardar y validar la información del cliente relacionada
    /*Object.keys(this.formClient.controls).forEach(key => {
      const control: any = this.formClient.get(key);
      if (control.invalid) {
        console.log(`Control "${key}" is invalid. Errors:`, control.errors);
      }
    });*/
    if (this.formClient.valid) {
      // validar el tema de sucursales incluidas
      this.listOfBrancheOffice.map((item: any) => {
        return {
          "idClienteSucursal": 0,
          "idCliente": this.selectedClient[0]?.idCliente ?? 0,
          "sucursal": item.sucursal,
          "activo": item.activo ?? false,
        }
      })

      //validar el canal de ingreso diligenciado
      if (this.selectedChannelIngreso?.idProcedencia == 0) {
        this.message.add({ severity: 'warn', detail: 'Favor seleccione la forma de ingreso' });
        return;
      }
      if (this.selectedListOfPrice.idListaPrecios == 0) {
        this.message.add({ severity: 'warn', detail: 'Favor seleccione la lista de precios a aplicar' });
        return;
      }
      this.load = true;
      this.citySelected = this.formClient.controls.ciudad.value;
      const data = {
        "idCliente": this.selectedClient[0]?.idCliente ?? 0,
        "idTipoIdentificacion": this.formClient.controls.tipo.value?.idTipoIdentificacion ?? 1,
        "digito": this.digito,
        "identificacion": this.formClient.controls.identificacion.value,
        "razonSocial": this.formClient.controls.razonSocial.value?.replace('No aplica', '') ?? '',
        "nombres": this.formClient.controls.nombres.value,
        "direccion": this.formClient.controls.direccion.value ?? '',
        "telefono": this.formClient.controls.telefono.value ?? '',
        "email": this.formClient.controls.correo.value,
        "idCiudad": !this.citySelected.idCiudad ? null : this.citySelected.idCiudad,
        "clienteProcedencia": this.selectedChannelIngreso?.idProcedencia > 0 ? [{
          idCliente: this.selectedClient[0]?.idCliente ?? 0,
          idProcedencia: this.selectedChannelIngreso.idProcedencia,
          idListaPrecios: this.selectedListOfPrice.idListaPrecios,
          fecha: new Date()
        }] : null,
        "clienteSucursals": this.listOfBrancheOffice
      }
      // SEND TO CREATE CLIENT
      this.client.setClient(this.token.token, data).subscribe({
        next: (response) => {
          this.load = false;
          this.message.add({ severity: 'success', detail: 'Procesamiento exítoso' });
          setTimeout(() => { this.formClient.reset(); this.clearFormClient(); }, 5000)
        },
        error: (error: HttpErrorResponse) => {
          this.load = false;
          this.message.add({ severity: 'danger', detail: 'Se ha presentado un error, favor validar la información' });
          this.config.handleError(error);
        }
      })

    } else
      this.message.add({ severity: 'warn', detail: 'Favor ingrese la información requerida' })




  }

  loadCities = () => {
    this.localizacion.getCities(this.token.token, (this.formClient.controls.departamento.value as any).idDepartamento).subscribe({
      next: (response) => {
        this.listCities = response as Array<any>;
        // there is a selected city
        if (this.citySelected?.idCiudad > 0)
          this.formClient.controls.ciudad.setValue(this.listCities.filter(row => row.idCiudad == this.citySelected?.idCiudad)[0]);
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); }
    })
  }

  getListofPrices = () => {
    this.cotizacion.getListOfPrice(this.token.token).subscribe({
      next: (response) => {
        this.listOfPrice = response as Array<any>;

      }, error: (error: HttpErrorResponse) => { }
    });
  }
}
